/* tslint:disable */

/**
 */
export class ViewCapability {
    CAP_EQP_DEPEND_ON_TS?: boolean;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/view-capability.ts